import { useForm } from "react-hook-form";
import { useState } from "react";
import { EnvelopeIcon } from "styles/icons";
import { useTranslations } from "contexts/LocalizationContext/hooks";
import axios from "axios";
import {
  ChakraFormControl as FormControl,
  ChakraInput as Input,
  ChakraStack as Stack,
  ChakraInputGroup as InputGroup,
  ChakraInputLeftElement as InputLeftElement,
  chakraChakra,
} from "@airhelp/react-ui-components";
import { FormSubmitButton, FormError, MarketingConsent } from "components/FormControl";
import config from "config/config";
import type { SubscribeFormProps } from "./Subscribe.d";

const { iterable: { iterableListIds } } = config;

const Form = chakraChakra("form");

const SubscribeForm = ({ setHasSubscribed, buttonText, listId, fullWidth, mobileView }: SubscribeFormProps) => {
  const [isError, setIsError] = useState(false);
  const {
    register,
    handleSubmit,
    watch,
    formState: { isSubmitting },
  } = useForm();

  const watchMarketingConsent = watch("marketingConsent", false);
  const translations = useTranslations();
  const desktopWidth = fullWidth ? "full" : "60%";

  const onSubmit = async ({ email, marketingConsent }) => {
    const payload = {
      listId: iterableListIds[listId],
      email,
      marketingConsent,
    };

    try {
      await axios.post("/api/iterable/", payload);
      setHasSubscribed(true);
    } catch (err) {
      setIsError(true);
      setHasSubscribed(false);
    }
  };

  return (
    <Form onSubmit={handleSubmit(onSubmit)} width={{ base: "full", lg: desktopWidth }}>
      <FormControl flexDir="column" display="flex">
        <Stack direction={mobileView ? "column" : { base: "column", md: "row" }} py={6} spacing={{ base: 3, md: 4 }}>
          <InputGroup w={mobileView ? "full" : { base: "full", md: 80 }}>
            <InputLeftElement pointerEvents="none">
              <EnvelopeIcon color="greyscale.500" w={5} h={4} />
            </InputLeftElement>
            <Input
              name="email"
              ref={register}
              required
              type="email"
              borderRadius="sm"
              placeholder={translations("enter_email_placeholder")}
            />
          </InputGroup>
          <FormSubmitButton
            text={buttonText}
            isDisabled={!watchMarketingConsent}
            isLoading={isSubmitting}
            display={mobileView ? "none" : { base: "none", md: "block" }}
            w={{ base: "full", md: 40 }}
            ml={6}
          />
        </Stack>
        <MarketingConsent register={register({ required: true })} text={translations("marketing_consent")} />
        <FormSubmitButton
          text={buttonText}
          isDisabled={!watchMarketingConsent}
          isLoading={isSubmitting}
          display={mobileView ? "base" : { base: "block", md: "none" }}
          w="full"
          mt={{ base: 0, md: 6 }}
        />
        {isError && (
          <FormError formErrorText={translations("subscribe_form_submit_error")} formError={isError} id="form-error" />
        )}
      </FormControl>
    </Form>
  );
};

export default SubscribeForm;
